import { render } from "./faça-seu-pedido.vue?vue&type=template&id=8ccdc03c&scoped=true&class=grid%20col-12"
import script from "./faça-seu-pedido.vue?vue&type=script&lang=js"
export * from "./faça-seu-pedido.vue?vue&type=script&lang=js"

import "./faça-seu-pedido.vue?vue&type=style&index=0&id=8ccdc03c&scoped=true&lang=scss"
import "./faça-seu-pedido.vue?vue&type=style&index=1&id=8ccdc03c&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ccdc03c"]])

export default __exports__